import React from 'react';

const SvgSemaphoreNeutralBw = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 17.81 17.81"
        {...props}
    >
        <defs>
            <linearGradient
                id="semaphore_neutral_bw_svg__a"
                x1={15.2}
                y1={16.25}
                x2={2.61}
                y2={28.85}
                gradientTransform="matrix(1 0 0 -1 0 31.46)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#b0adad" />
                <stop offset={1} stopColor="#e4e4e5" />
            </linearGradient>
            <linearGradient
                id="semaphore_neutral_bw_svg__b"
                x1={7.44}
                y1={23.91}
                x2={10.38}
                y2={20.96}
                gradientTransform="matrix(1 0 0 -1 0 31.46)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#fff" stopOpacity={0} />
                <stop offset={1} stopColor="#010101" stopOpacity={0.75} />
            </linearGradient>
        </defs>
        <g data-name="Vrstva 2">
            <g data-name="Vrstva 1">
                <g data-name="Vrstva 2">
                    <g data-name="\u0160ed\xFD \u017Elut\xFD">
                        <circle
                            cx={8.91}
                            cy={8.91}
                            r={8.91}
                            style={{
                                fill: "url(#semaphore_neutral_bw_svg__a)",
                            }}
                        />
                        <image
                            width={43}
                            height={43}
                            transform="matrix(.16 0 0 .16 5.56 5.69)"
                            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAEX5AABF+QF95BF0AAAEw0lEQVRYR9WZa1PbSBBFj18gbAIkJIRks/v//1cqm0rW4WUTDMJoP/RcpmckWTJQSaWrumyDaub4qqfnjjyoqoo/JcZdF/SJSVEM2v5XrlYvpsbgKco6uIFL3CtA5V6Vz4LfCjZAKocNqf8J7qEhK6B6CnRv2AA6BEYhx8Ak5DikgAV6H7J07+9x4NtA94KdFIWUGwM7wC5QZClowQryFliFvA1ZhlwDD32BO2ED6AiDKYApsB/yVXidEoEFK9CfIZchr8PnFXAXrnsoV6sHOmIjrAPdAfYwuEPgTcjXwAEGvIfBDrFbXGJA18ACuAIuQl6Gz9fhmhJYdwG3tq4MdIpBHQPvgPfASfh8RIRV3UpZD3sBnAFz4L8w7ojYQapJUWys4UZYt5gmGMQBBnkKfAx5CrzFlJ5idexh77EyuMFu/yXww10vWHDtbVIUrTVcg81AC+zWH2Nwf4f8C1P3DaZqgU2ubgC2eEqsLlWzh+56za3OsCaWTz9YbDLd/hlWl++BT8A/IT9gqh4Qa3VEvXWpfc1IF6Lm9V/oLly7biuHBLZB1QMM6hRT8xMGekL9dnpVIQJPiO1OXwoM1HeLGyKwNo8kcmU97BQDEuyH8PoOW1Qz0kXit9zKjVWRfpkBBnpH2ikWGPQtLeo+wrqtdIypMMOg3mJKnmA1ekBdUUhV9e8hW/WYCCtiOzsLrwtM4ZIGdYekoV1qF6uxIwzwmNhTu0Dz0P/8DjjFFu7rkFp4vlfXwv9Rt22M1es+BndEOtg2oIo2YM2hjUW74AgY5NbT12y+uPTt/Za6y/agiibgPWxcdYkdUkOUxBCSevVlsIfV7YyoqB9oG1Af2hnl2tQpfLdoHL+pZmVadl3uEGupsZ56hu8Y3mqO3edGVaE+sdT1g2ig1kGeEYOGhJ6wvzqqhoSsZSlyWO06a1Jnvw7ZyyRvCA+jMfM5GncvqMMKtMnha8DWwXqGF0O+wJ8gJEptjiE8njil6j0G+BPbDpdEZ79xsI7I57jDdit5A50cWr2BV1YDedN8SerqpfDjKZV+oes8qGzjVcglmSCt3oA6rNz9ecgjrHmrhalzwOYu0Qa6II59icF6X1CL3HX5MlhisHMM1HtXQXrwvO34xZSDXhKPOPPw/ooNJgYcbLlaVZOi0CqVfbvAzkuvsJ1M2y3YgDLSufFWeAMu0HMM8FvI7+FvS1yZdZpvYkvRwBeYmnvEMxbEjrFPuk36jUNj5YrOgX+BL8BXTIwL4ppobZEJrFPXl8IPUofvD4KHmOKJWwrXNdXoGabmF+AzBj0nlkCrqtB8BpMiJTaJ9wM6ilxjE8jjqkRkdHRtSTzd+tv/FQP9hn2BJbFttXaYGmxQF6KCXilNrk7RZJz9HZCqV0TY79it18JaEFvWxkdJTcoK2HcGrWg1ct1SGXNvI0fEu6MD4RWxA5xjXzTvrZ3PvLoeH3mP6025jtbqEv5ZV356Ve1rA9DzLp1mX+ZZFyTGXLZxJ2TbU0TVrMrmDgO+CSkfIAPTqaiiExYS4Nw0Nz2fHRK3Ym9YlIkh6gsKPWEVWzz5htS4CE65FaRiK1hFz98UIAI/br1PgVQ8CTaPTb/WAM/60cPHi8D+qvjdZ7Ct4o+C/R8/xmhf8q/3DQAAAABJRU5ErkJggg=="
                            style={{
                                opacity: 0.25,
                                isolation: "isolate",
                            }}
                        />
                        <circle
                            cx={8.91}
                            cy={9.02}
                            r={2.08}
                            style={{
                                fill: "#fff",
                            }}
                        />
                        <circle
                            cx={8.91}
                            cy={9.02}
                            r={2.08}
                            style={{
                                fill: "url(#semaphore_neutral_bw_svg__b)",
                                opacity: 0.25,
                                isolation: "isolate",
                            }}
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default SvgSemaphoreNeutralBw;